import { GKTextArea, Grid2, Typography } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";

const DisclosureForm = () => {
  const form = useFormContext<WebsiteDetails>();

  return (
    <Grid2 container spacing={4} p={2}>
      <Grid2 size={12}>
        <Typography fontSize={14} fontWeight={700} color="var(neutral-900)">
          Disclosure
        </Typography>
      </Grid2>
      <Grid2 size={8}>
        <Controller
          control={form.control}
          name="compliance.disclosure"
          render={({ field }) => (
            <GKTextArea {...field} placeholder="Disclosure" rows={8} />
          )}
        />
      </Grid2>
    </Grid2>
  );
};

export default DisclosureForm;
